import { Injectable } from '@angular/core';

@Injectable()
export class CompareParameterSingleService {

  private storageCurves: any = {};

  constructor() {
  }

  setStorageCurve(val: any) {
    this.storageCurves = val;
  }

  getStorageCurve() {
    return this.storageCurves;
  }

  isCompareArray(a, b) {
    if (a && b) {
      if (a.length !== b.length) {
        return false;
      } else {
        for (let i = 0; i < a.length; i++) {
          if (a[i] !== b[i]) {
            return false;
          }
        }
        return true;
      }
    } else {
      return false;
    }
  }

  isCheckStorageCurveData(storageLogFile: string, logFile: string, selectedCurve: any, curve: any) {
    if (storageLogFile === logFile && this.isCompareArray(selectedCurve, curve)) {
      return true;
    }
    return false;
  }
}
